export default __webpack_public_path__ + "static/media/newstoday.8beb39c2.jpg";